
// 全局参数
let globals = {
	baseUrl: process.env.VUE_APP_URL || 'https://lavrockd.nsw99.com',
	basImagePath:
		process.env.VUE_APP_BASIMAGEPATH || 'https://lavrock-dev.51yxwz.com/',
	jiaye: 'http://wxbtest.nsw99.com/jiayestatic/#/',
	xuanwo: 'https://xuanwot.nsw99.com/#/index',
	gdj: 'http://www.laile88.cn/#/oauth',
	sss: 'https://ssst.nsw99.com/',
	nswUrl: 'https://nsytestwebauth.nsw888.com/',
}

export default {
	globals,
	confirmLogin: false,
	showWjx: false,
	showRecycle: 1,
	isCollapse: false,
	isRefresh: 1,//判断是否需要刷新页面
	projListData: [],
	projectInfo: {
		id: '',
		projName: ''
	}


}
